<dms-control [dmsTraduction]="this.dmsTraduction" >
	<textarea class="textarea form-control" name="name" resize="none" maxlength="4096" style="transition: height 0.2s ease 0s; min-height: 50px; max-height: 180px; resize: none; overflow: hidden; overflow-wrap: break-word; height: 54px;"></textarea>
</dms-control>